var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-258c9d36-ba07-402b-a2ee-8d63df2abdde",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-b5209df8-9577-4dd6-8fd4-0f9c49a57146 {\n        fill: none;\n        stroke: #fce3bf;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 80px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-95a8430b-caa9-4bba-bbab-ecb82081bf95",
    "data-name": "Free-Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-b94fe593-40bd-4cbd-a0c5-1679218606ed",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-1a36b7b2-76e4-49a8-9287-be894b88ff3b",
    "data-name": "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-b5209df8-9577-4dd6-8fd4-0f9c49a57146",
    d: "m600,400.03l-199.97,199.97-204.45-199.97m204.45,199.9V40"
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-b5209df8-9577-4dd6-8fd4-0f9c49a57146",
    x1: 40,
    y1: 760.03,
    x2: 760,
    y2: 760.03
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.e5d9654c1c3fb34be8ea113301e82b7f.svg";
export { ForwardRef as ReactComponent };